import React from 'react';
import { Helmet } from 'react-helmet-async';
import Form from '../Common/Form';
import joi from 'joi';
import Swal from 'sweetalert2';

import './contact.css';

const recaptchaRef = React.createRef();


class Contact extends Form {
    //State where errors and form data is stored
    state = {
        data: {
            nameKanji: "",
            nameKana: "",
            phoneNumber: "",
            email: "",
            placeName: "",
            occupation: "会社員",
            contactType: "サービスに関するご質問",
            content: "",
            captchaToken: ""
        },
        errors: {},
        displayMessage: false,
        userVerified: false,
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    //Schema of validation
    schema = joi.object({
        nameKanji: joi.string()
            .empty()
            .regex(/[0-9０-９]/, { invert: true })
            .messages({
                'string.empty': "入力必須な項目です。",
                'string.pattern.invert.base': '数字は許されません。'
            }),
        nameKana: joi.string()
            .empty()
            .regex(/[0-9０-９]/, { invert: true })
            .messages({
                'string.empty': "入力必須な項目です。",
                'string.pattern.invert.base': '数字は許されません。'
            }),
        phoneNumber: joi.string()
            .empty()
            .regex(/^[0-9-]{10,13}$/i)　//06-6347-5575
            //.regex(/^(?:\d{10}|\d{3}-\d{3}-\d{4}|\d{2}-\d{4}-\d{4}|\d{3}-\d{4}-\d{4})$/)　//06-6347-5575
            .messages({
                'string.pattern.base': "半角数字で入力ください",
                'string.empty': "入力必須な項目です。"
            }),
        email: joi.string()
            .email({ tlds: { allow: false } })
            .empty()
            .messages({
                'string.empty': "入力必須な項目です。",
                'string.email': '入力されたメールアドレスに間違いがあります。'
            }),
        placeName: joi.string()
            .empty()
            .messages({
                'string.empty': "入力必須な項目です。"
            }),
        content: joi.string()
            .empty()
            .messages({
                "string.empty": "入力必須な項目です。"
            }),
        contactType: joi.string()
            .empty()
            .messages({
                'string.empty': "入力必須な項目です。"
            }),
        occupation: joi.string()
            .empty()
            .messages({
                "string.empty": "入力必須な項目です。"
            }),
        captchaToken: joi.string().empty().messages({
            "string.empty": "Captchaを確認してください。"
        }),

    })

    // Contact type options for radio
    contactTypeOptions = [
        {

            id: 1,
            optionName: "サービスに関するご質問"
        },
        {
            id: 2,
            optionName: "資料請求"
        },
        {
            id: 3,
            optionName: "採用に関するご質問"
        },
        {
            id: 4,
            optionName: "その他"
        }
    ]

    //Occupation Options for radio
    occupationOptions = [
        {
            id: 5,
            optionName: "会社員"
        },
        {
            id: 6,
            optionName: "学生"
        },
        {
            id: 7,
            optionName: "その他"
        }
    ]

    //This method will handle the sending of email
    //Before this method can run, there is validation method from the Parent Class
    doSubmit = async () => {
        //BlankState or Former State (元の状態)
        const blankState = {
            nameKanji: "",
            nameKana: "",
            phoneNumber: "",
            email: "",
            placeName: "",
            occupation: "会社員",
            contactType: "サービスに関するご質問",
            content: "",
            captchaToken: ""
        }

        const formData = new FormData();
        let data = { ...this.state.data };
        Object.keys(data).map(function (key) {
            formData.append(key, data[key])
            return null;
        })
        //Sweet alert loading
        Swal.fire({
            title: "読み込み中",
            didOpen: function () {
                Swal.showLoading()
            }
        })
        await fetch(this.emailEndPoint, {
            method: "POST",
            body: formData
        }).then(function (response) {
            if (!response.ok) {
                Swal.fire({
                    title: "エラー！",
                    text: "エラーが発生しました。後でもう一度お試しください。",
                    icon: "error",
                    confirmButtonText: "OK"
                })
            }
            else {
                //Sweet alert Success
                Swal.fire({
                    title: "成功！",
                    text: "メールが送信されました。",
                    icon: "success",
                    confirmButtonText: "OK"
                })
            }

        }).catch(function () {
            Swal.fire({
                title: "エラー！",
                text: "エラーが発生しました。後でもう一度お試しください。",
                icon: "error",
                confirmButtonText: "OK"
            })
        });

        //after alert, delete data to reset form
        this.setState({ data: blankState, userVerified: false });
        //reset captcha
        recaptchaRef.current.reset();

    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>お問い合わせ | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div className='container-box banner-container' id='contact-banner-container'>
                    <div className='overlay'></div>
                    <div className='row'>
                        <div className='col'>
                            <h1>お問い合わせ</h1>
                            <h3>CONTACT US</h3>
                        </div>
                    </div>
                </div>
                <div className="contact_container mt-5 pb-5">
                    <div className="row">
                        <div className="col ">
                            <p className="card-text">弊社へのお問合せ・ご質問等はこちらより承ります。<br />
                                下記の必要事項を入力のうえ、「確認する」ボタンを押し、送信ください。</p>
                            <form className="contact-form" method="GET">
                                {/* <div className="row row-title mb-3">
                                    <div className="col col-hr"><hr /></div>
                                    <div className="col-12 col-md-6">
                                        <h2 className="text-orange">お問合せ種別</h2>
                                    </div>
                                    <div className="col col-hr"><hr /></div>
                                </div> */}
                                {this.renderInputRadio("contactType", "種別", this.contactTypeOptions, this.contactTypeOptions[0])}
                                <div className="row row-title mb-3 mt-1">
                                    <div className="col col-hr"><hr /></div>
                                    <div className="col-12 col-md-6">
                                        <h2 className="text-orange">お客様情報</h2>
                                    </div>
                                    <div className="col col-hr"><hr /></div>
                                </div>
                                {this.renderInputText("nameKanji", "お名前（氏名）")}
                                {this.renderInputText("nameKana", "お名前（カナ）")}
                                {this.renderInputText("phoneNumber", "電話番号")}
                                {this.renderInputText("email", "メールアドレス", "※携帯・PCどちらでも可", true, "email")}
                                {this.renderInputRadio("occupation", "職業", this.occupationOptions, this.occupationOptions[0])}
                                {this.renderInputText("placeName", "会社名・学校名", "※学校名の場合学部・学科まで記載ください。")}
                                <div className="row row-title mb-2 mt-3">
                                    <div className="col col-hr"><hr /></div>
                                    <div className="col-12 col-md-6">
                                        <h2 className="text-orange">お問い合わせ内容</h2>
                                    </div>
                                    <div className="col col-hr"><hr /></div>
                                </div>
                                <small>弊社へのお問合せ・ご質問を記入ください。</small>
                                {this.renderInputTextArea("content", "お問い合わせ", "", "200px")}
                                {this.renderCaptcha(recaptchaRef, "mt-3")}

                                <ul className="mt-3 contact_privacy_content ">
                                    <li>・ <a href="/privacy-policy" target="_blank">個人情報保護方針</a>をお読みいただき、同意いただける場合は「確認する」ボタンを押してください。</li>
                                    <li>・ 内容によっては回答を差し上げるまでにお時間をいただくこともございます。</li>
                                    <li>・ お客様からお預かりした個人情報を含む情報は全てを適切に処理し管理いたします。</li>
                                    <li>・ 上記情報は目的外に使用することは無く部外者に提供する事はありません。</li>
                                </ul>

                                {this.renderSubmitButton("contact_btn bg-orange mt-3", "確認する")}
                                {this.renderErrorForm()}
                            </form>
                        </div>
                    </div>
                </div>

            </React.Fragment >
        );
    }
}

export default Contact;